import React from 'react'
import cx from 'clsx'

import * as styles from './Container.module.scss'

const Container = ({ children, className }) => <div className={cx([styles.container, className])}>{children}</div>

export { Container }
